import { ThemedRequestMoney as RequestMoney } from './request-money';
export const ThemedRequestMoney = RequestMoney;
